
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class DropdownItem extends Vue {
  @Prop({ default: '' }) path!: string
}
